/* TS Design Works studio theme: interactions for ts-* sections.
   Every init is idempotent and re-run on Shopify theme-editor section reloads. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---- hover image preview (services + industries) ---- */
  let peek = document.getElementById('peek');
  if (!peek) { peek = document.createElement('div'); peek.id = 'peek'; document.body.appendChild(peek); }
  function bindPeek(root) {
    $$('[data-peek]', root).forEach(el => {
      if (el.dataset.peekBound) return; el.dataset.peekBound = 1;
      const pre = new Image(); pre.src = el.dataset.peek;
      el.addEventListener('mouseenter', () => { peek.innerHTML = '<img src="' + el.dataset.peek + '" alt="">'; peek.classList.add('on'); });
      el.addEventListener('mouseleave', () => peek.classList.remove('on'));
      el.addEventListener('mousemove', e => { peek.style.left = Math.min(e.clientX + 260, innerWidth - peek.offsetWidth / 2 - 16) + 'px'; peek.style.top = e.clientY + 'px'; });
    });
  }

  /* ---- service filter + expandable rows ---- */
  function bindServices(root) {
    $$('.toggle button', root).forEach(b => b.onclick = () => {
      $$('.toggle button', root).forEach(x => x.classList.toggle('on', x === b));
      $$('[data-g]', root).forEach(el => el.classList.toggle('hide', !(b.dataset.f === 'all' || el.dataset.g === b.dataset.f)));
    });
    $$('.r', root).forEach(r => r.onclick = () => r.classList.toggle('open'));
  }

  /* ---- FAQ ---- */
  function bindFaq(root) { $$('.q button', root).forEach(b => b.onclick = () => b.parentNode.classList.toggle('open')); }

  /* ---- contact chips -> hidden field ---- */
  function bindContact(root) {
    const form = $('.intake', root); if (!form) return;
    const hidden = $('input[data-interest]', form);
    const sync = () => { if (hidden) hidden.value = $$('.chips button.on', form).map(b => b.textContent.trim()).join(', '); };
    $$('.chips button', form).forEach(b => b.onclick = () => { b.classList.toggle('on'); sync(); });
    sync();
  }

  /* ---- reveal on scroll ---- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { threshold: .15 }) : null;
  function bindReveal(root) { $$('.reveal', root).forEach(el => io ? io.observe(el) : el.classList.add('in')); }

  /* ---- rotating hero word ---- */
  function bindSwap(root) {
    const track = $('.swap .track', root); if (!track || track.dataset.bound) return; track.dataset.bound = 1;
    const n = track.children.length - 1; if (n < 1) return; let i = 0;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(() => {
      i++; track.style.transition = ''; track.style.transform = `translateY(${-i * track.children[0].offsetHeight}px)`;
      if (i === n) setTimeout(() => { track.style.transition = 'none'; track.style.transform = 'translateY(0)'; i = 0; }, 850);
    }, 3000);
  }

  /* ---- ghosted flowing code cloud ---- */
  function bindCodeCloud(root) {
    const wrap = $('.ts-codefield', root); if (!wrap || wrap.dataset.bound) return; wrap.dataset.bound = 1;
    const cv = $('canvas', wrap), ctx = cv.getContext('2d');
    const strength = (+wrap.dataset.strength || 55) / 100;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const SRC = `const agent = await ai.create({ model, tools: [quote, schedule, email] });
for (const job of queue) { const est = await agent.run(job.brief); if (est.ok) send(est); }
export function automate(flow) { return flow.steps.map(s => s.trigger ? run(s) : skip(s)); }
scan.mesh().simplify(0.02).toCAD({ units: "mm", tolerance: 0.05 }).export("part.step");
def classify(ticket): return llm.predict(prompt=f"route: {ticket.body}", labels=TEAMS)
SELECT customer, SUM(total) FROM orders WHERE created > now() - interval '30 days' GROUP BY 1;
pipeline.on("lead", async (l) => { await crm.upsert(l); await notify(owner(l)); });
model.fit(X_train, y_train); preds = model.predict(X_test); dashboard.push(preds)
if (inventory.low(sku)) { po = draft_purchase_order(sku); approve(po) } // human in loop
`.replace(/\n/g, '   ');
    const GL = '{}[]()<>=+-*/;:._$#&|~!?01';
    let W, H, cols, rows, cell, fs, rowSpeed = [], flick = new Map(), t = 0, last = 0, vis = true, quiet = [];
    function size() {
      const r = wrap.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, r.width < 700 ? 1.5 : 2);
      W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      fs = W < 600 ? 11 : 13; cell = { w: fs * .68, h: fs * 1.35 };
      cols = Math.ceil(W / cell.w); rows = Math.ceil(H / cell.h);
      rowSpeed = Array.from({ length: rows }, (_, i) => (.6 + ((i * 73) % 17) / 17 * 1.6) * (i % 2 ? 1 : -1));
      ctx.font = `500 ${fs}px ui-monospace,"SFMono-Regular",Consolas,monospace`; ctx.textBaseline = 'top';
      quiet = $$('.hero h1,.hero .row p,.hero .kicker,.hero .btn', root).concat($$('.ts-header .brand,.ts-header nav'))
        .map(e => { const b = e.getBoundingClientRect(); return { x: b.left - r.left - 24, y: b.top - r.top - 18, w: b.width + 48, h: b.height + 36 }; });
    }
    const dim = (x, y) => { let m = 1; for (const q of quiet) { const dx = Math.max(q.x - x, 0, x - (q.x + q.w)), dy = Math.max(q.y - y, 0, y - (q.y + q.h)); const d = Math.hypot(dx, dy); if (d < 40) m = Math.min(m, .18 + .82 * (d / 40)); } return m; };
    const field = (x, y, t) => {
      const a = Math.sin(x * .011 + t * .35) + Math.sin(y * .019 - t * .27);
      const b = Math.sin((x + y) * .007 + t * .22) + Math.sin(Math.hypot(x - W * .5 - Math.sin(t * .15) * W * .35, y - H * .45 - Math.cos(t * .11) * H * .2) * .014 - t * .9);
      return (a * .5 + b * .6) / 2.2 + .5;
    };
    function draw() {
      ctx.clearRect(0, 0, W, H);
      for (let r = 0; r < rows; r++) {
        const off = Math.floor(t * rowSpeed[r] * 3), y = r * cell.h;
        for (let c = 0; c < cols; c++) {
          const x = c * cell.w, f = field(x, y, t); if (f < .42) continue;
          const k = (f - .42) / .58, a = Math.min(1, k * k * 1.6) * strength * dim(x, y); if (a < .02) continue;
          let ch = SRC[((r * 131 + c + off) % SRC.length + SRC.length) % SRC.length];
          const key = r * 1000 + c, fl = flick.get(key);
          if (fl && fl.until > t) ch = fl.ch; else if (Math.random() < .004 * k) flick.set(key, { ch: GL[(Math.random() * GL.length) | 0], until: t + .25 });
          if (ch === ' ') continue;
          ctx.fillStyle = `rgba(255,90,31,${k > .8 ? Math.min(.9, a * 1.5) : a})`;
          ctx.fillText(ch, x, y);
        }
      }
      if (flick.size > 4000) flick.clear();
    }
    function frame(now) {
      requestAnimationFrame(frame);
      if (!vis || document.hidden || now - last < (W < 700 ? 42 : 33)) return;
      t += Math.min((now - last) / 1000, .1); last = now; draw();
    }
    size(); addEventListener('resize', size); document.fonts && document.fonts.ready.then(size);
    new IntersectionObserver(e => vis = e[0].isIntersecting).observe(wrap);
    if (reduce) { t = 3; draw(); } else requestAnimationFrame(frame);
  }

  /* ---- header state, floating bar, active nav ---- */
  function bindChrome() {
    const hdr = $('.ts-header'), fab = $('.tsx .fab'), hero = $('.tsx .hero'), contact = document.getElementById('contact');
    const links = $$('.ts-header nav a'), secs = $$('.tsx section[id]');
    const onScroll = () => {
      const y = scrollY, cTop = contact ? contact.getBoundingClientRect().top + y : Infinity;
      if (hdr) { hdr.classList.toggle('solid', y > 40 && y + 40 < cTop); hdr.classList.toggle('dark', y + 40 >= cTop); }
      if (fab && hero) fab.classList.toggle('show', y > hero.offsetHeight * .8 && y + innerHeight < cTop + 120);
      let cur = ''; secs.forEach(s => { if (y >= s.getBoundingClientRect().top + y - 200) cur = s.id; });
      links.forEach(a => a.classList.toggle('on', !!cur && a.getAttribute('href').endsWith('#' + cur)));
    };
    removeEventListener('scroll', window.__tsScroll || (() => {})); window.__tsScroll = onScroll;
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  function init(root = document) {
    bindPeek(root); bindServices(root); bindFaq(root); bindContact(root); bindReveal(root); bindSwap(root); bindCodeCloud(root); bindChrome();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
